export default __webpack_public_path__ + "static/media/Expenses.0209e53a.png";